$('.js-catalog-toggleChild').click(function () {
    var child = $(this).attr('data-child');
    var childLevel = $(this).attr('data-child-level');

    $('.js-catalog-child'+parseInt(childLevel)).addClass('D(n)');
    $('.js-catalog-child'+(parseInt(childLevel) + 1)).addClass('D(n)');
    $('.js-catalog-child'+(parseInt(childLevel) + 2)).addClass('D(n)');
    setTimeout(function () {
        $('.js-catalog-child'+childLevel+'[data-ref="'+child+'"]').removeClass('D(n)');
    }, 100);
});
